import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

// 1. MATERIAL UI КОМПОНЕНТИ
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Avatar,
  Chip,
  useTheme,
  useMediaQuery,
  Collapse,
  Popover,      // Було відсутнє
  Stack,        // Було відсутнє
  Button,       // Було відсутнє
  Badge,        // Було відсутнє
  CssBaseline,  // Було відсутнє
  alpha         // Було відсутнє
} from '@mui/material';

// 2. ІКОНКИ (Виправлено та очищено від дублікатів)
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import ArchiveIcon from '@mui/icons-material/Archive';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt'; // <--- ОСЬ ЦЬОГО НЕ ВИСТАЧАЛО
import HandymanIcon from '@mui/icons-material/Handyman';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import BugReportIcon from '@mui/icons-material/BugReport';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import InfoIcon from '@mui/icons-material/Info';
import SummarizeIcon from '@mui/icons-material/Summarize';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SpeedIcon from '@mui/icons-material/Speed';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CountertopsIcon from '@mui/icons-material/Countertops';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SensorsIcon from '@mui/icons-material/Sensors';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';
import NotificationCenter from './NotificationCenter';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BeachAccess } from '@mui/icons-material';
import TrendingUp from '@mui/icons-material/TrendingUp';
import MenuBook from '@mui/icons-material/MenuBook';
import IntegrationInstructions from '@mui/icons-material/IntegrationInstructions';
import ComputerIcon from '@mui/icons-material/Computer';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import SyncIcon from '@mui/icons-material/Sync';

// *** 1. ІМПОРТИ ДЛЯ ПОГОДИ ***
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import WbCloudyIcon from '@mui/icons-material/WbCloudy';
import AirIcon from '@mui/icons-material/Air';
import OpacityIcon from '@mui/icons-material/Opacity';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import GrainIcon from '@mui/icons-material/Grain';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TimelineIcon from '@mui/icons-material/Timeline';
import PsychologyIcon from '@mui/icons-material/Psychology';

import { useI18n } from '../i18n/i18n';
import { getData } from '../services/storageService';
import useHasSettingsAccess from '../hooks/useHasSettingsAccess';

// *** ДОДАЄМО ІМПОРТ ДЛЯ СПОВІЩЕНЬ ***
import { useNotifications } from '../context/NotificationContext';
import NotificationPanel from './NotificationPanel/NotificationPanel';

// *** ЗМІНЕНО ІМПОРТ PACKAGE.JSON (ВИПРАВЛЕННЯ ПОМИЛКИ) ***
import pkg from '../../package.json';

const LainsaLogo = `${process.env.PUBLIC_URL}/logo512.png`;
const DevLogo = `${process.env.PUBLIC_URL}/svh_logo.png`;
const drawerWidth = 260;
const FOOTER_H = 84; // Висота футера (збільшено для двох рядків)

// *** 2. ОНОВЛЕНИЙ КОМПОНЕНТ ПОГОДИ (з реальним API) ***
const CompactWeather = () => {
  const { t, lang } = useI18n(); 
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [weather, setWeather] = useState(null); // Дані з API
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- ❗️ ВАШІ НАЛАШТУВАННЯ ---
  const API_KEY = "1ad9315e82604a54884130225251411"; // Ваш ключ
  
  // Вкажіть місто. 
  // 'auto:ip' - автоматично за IP (рекомендовано)
  // 'Palma' - конкретне місто
  // 'London'
  // 'Kyiv'
  const LOCATION_QUERY = "Mahon"; 
  // ------------------------------

  // Функція для отримання іконки погоди на основі коду з API
  const getWeatherIcon = (code) => {
    const iconProps = { sx: { fontSize: 16, mr: 1 } };
    switch (code) {
      case 1000: return <WbSunnyIcon {...iconProps} style={{ color: '#fbc02d' }} />; // Sunny
      case 1003: return <WbCloudyIcon {...iconProps} style={{ color: '#b0bec5' }} />; // Partly cloudy
      case 1006: return <CloudQueueIcon {...iconProps} style={{ color: '#90a4ae' }} />; // Cloudy
      case 1009: return <CloudQueueIcon {...iconProps} style={{ color: '#90a4ae' }} />; // Overcast
      case 1063: // Patchy rain
      case 1180: // Patchy light rain
      case 1183: // Light rain
      case 1186: // Moderate rain at times
      case 1189: // Moderate rain
      case 1192: // Heavy rain at times
      case 1195: // Heavy rain
        return <GrainIcon {...iconProps} style={{ color: '#42a5f5' }} />;
      case 1087: return <ThunderstormIcon {...iconProps} style={{ color: '#ffeb3b' }} />; // Thundery outbreaks
      case 1210: // Patchy light snow
      case 1213: // Light snow
      case 1216: // Patchy moderate snow
      case 1219: // Moderate snow
      case 1222: // Patchy heavy snow
      case 1225: // Heavy snow
        return <AcUnitIcon {...iconProps} style={{ color: '#81d4fa' }} />;
      default:
        return <HelpOutlineIcon {...iconProps} style={{ color: 'rgba(255,255,255,0.7)' }} />;
    }
  };

  const fetchWeather = () => {
    setLoading(true);
    setError(null);
    
    // Формуємо URL
    const url = `https://api.weatherapi.com/v1/current.json?key=${API_KEY}&q=${LOCATION_QUERY}&lang=${lang}`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          // Обробка помилок API (напр. невірний ключ або місто не знайдено)
          setError(data.error.message || t('weather.city_not_found'));
          console.error("WeatherAPI Error:", data.error.message);
        } else {
          // Успішно отримано дані
          setWeather({
            temp: Math.round(data.current.temp_c),
            feels_like: Math.round(data.current.feelslike_c),
            humidity: data.current.humidity,
            wind: (data.current.wind_kph / 3.6).toFixed(1), // Переводимо км/г в м/с
            desc: data.current.condition.text,
            icon: getWeatherIcon(data.current.condition.code),
            location: data.location.name, // Зберігаємо назву міста
          });
        }
        setLoading(false);
      })
      .catch(err => {
        // Загальна помилка мережі
        console.error("Fetch Weather Error:", err);
        setError(t('weather.error_desc'));
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchWeather();
    // Оновлювати погоду кожні 15 хвилин
    const interval = setInterval(fetchWeather, 15 * 60 * 1000); 
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]); // Перезавантажуємо погоду при зміні мови (щоб отримати 'desc' іншою мовою)

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  let weatherIcon;
  let weatherText;

  if (loading) {
    weatherIcon = <HelpOutlineIcon sx={{ fontSize: 16, mr: 0.5, color: 'rgba(255,255,255,0.7)' }} />;
    weatherText = t('weather.loading');
  } else if (error) {
    weatherIcon = <ErrorOutlineIcon sx={{ fontSize: 16, mr: 0.5, color: theme.palette.error.light }} />;
    weatherText = t('weather.error');
  } else if (weather) {
    weatherIcon = weather.icon;
    weatherText = `${weather.temp}°C`;
  }

<NotificationCenter />

  return (
    <>
      <IconButton
        onClick={handleClick}
        title={t('weather.title')}
        sx={{
          color: 'white',
          background: alpha(theme.palette.common.white, 0.1),
          borderRadius: 2,
          px: 1.5,
          py: 0.5,
          border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
          '&:hover': {
            background: alpha(theme.palette.common.white, 0.2),
          },
          minWidth: 90 // Щоб уникнути стрибка при завантаженні
        }}
      >
        {weatherIcon}
        <Typography variant="body2" sx={{ 
          fontWeight: 600,
          fontFamily: 'monospace',
          fontSize: '0.8rem'
        }}>
          {weatherText}
        </Typography>
      </IconButton>

      {/* Розширений Popover */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPopover-paper': {
            borderRadius: 3,
            background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.default, 0.98)} 100%)`,
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          }
        }}
      >
        <Box sx={{ p: 2, minWidth: 260 }}>
          {loading ? (
            <Typography sx={{ p: 2, textAlign: 'center' }}>{t('weather.loading')}</Typography>
          ) : error ? (
            // Блок помилки
            <Stack spacing={1.5} sx={{ p: 1, alignItems: 'center' }}>
              <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }}/>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>{t('weather.error')}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>{error}</Typography>
              <Button onClick={fetchWeather} variant="outlined" size="small">
                {t('weather.try_again')}
              </Button>
            </Stack>
          ) : (
            // Блок погоди
            <Stack spacing={1.5}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {React.cloneElement(weather.icon, { sx: { fontSize: 20, color: 'primary.main' } })}
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {weather.location || t('weather.location')}
                </Typography>
              </Box>
              
              <Divider />

              <Box sx={{ textAlign: 'center', my: 1 }}>
                <Typography variant="h3" sx={{ fontWeight: 700 }}>
                  {weather.temp}°C
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ textTransform: 'capitalize' }}>
                  {weather.desc}
                </Typography>
              </Box>

              <Divider />

              <Stack spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <DeviceThermostatIcon fontSize="small" color="action" />
                  <Typography variant="body2">
                    {t('weather.feels_like')}: <strong>{weather.feels_like}°C</strong>
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <OpacityIcon fontSize="small" color="action" />
                  <Typography variant="body2">
                    {t('weather.humidity')}: <strong>{weather.humidity}%</strong>
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <AirIcon fontSize="small" color="action" />
                  <Typography variant="body2">
                    {t('weather.wind')}: <strong>{weather.wind} {t('weather.speed_ms')}</strong>
                  </Typography>
                </Box>
              </Stack>
            </Stack>
          )}
        </Box>
      </Popover>
    </>
  );
};


// 🕐 Компактний компонент годинника для верхньої панелі
const CompactClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const { t, lang } = useI18n(); // <-- ОНОВЛЕНО: Додано i18n

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // *** ОНОВЛЕНО: Формат часу, дати та дня тижня ***
  const formattedTime = currentTime.toLocaleTimeString(lang, { // Використовуємо 'lang'
    hour: '2-digit',
    minute: '2-digit'
  });

  const dayOfMonth = currentTime.getDate();
  // Отримуємо короткий день тижня і робимо першу літеру великою
  const shortWeekday = currentTime.toLocaleDateString(lang, { weekday: 'short' });
  const formattedDayInfo = `${dayOfMonth} ${shortWeekday.charAt(0).toUpperCase() + shortWeekday.slice(1)}`;

  // Формат дати для Popover
  const formattedDatePopover = currentTime.toLocaleDateString(lang, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          color: 'white',
          background: alpha(theme.palette.common.white, 0.1),
          borderRadius: 2,
          px: 1.5,
          py: 0.5,
          border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
          '&:hover': {
            background: alpha(theme.palette.common.white, 0.2),
          }
        }}
      >
        {/* *** ОНОВЛЕНО: Новий вигляд годинника *** */}
        <CalendarTodayIcon sx={{ fontSize: 16, mr: 1 }} />
        <Typography variant="body2" sx={{ 
          fontWeight: 600,
          fontFamily: 'monospace',
          fontSize: '0.8rem',
          minWidth: '35px', // Для стабільної ширини
          textTransform: 'capitalize' // Для дня тижня
        }}>
          {formattedDayInfo}
        </Typography>
        
        <Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: 'rgba(255,255,255,0.3)' }} />
        
        <AccessTimeIcon sx={{ fontSize: 16, mr: 0.5 }} />
        <Typography variant="body2" sx={{ 
          fontWeight: 600,
          fontFamily: 'monospace',
          fontSize: '0.8rem'
        }}>
          {formattedTime}
        </Typography>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPopover-paper': {
            borderRadius: 3,
            background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.default, 0.98)} 100%)`,
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          }
        }}
      >
        <Box sx={{ p: 2, minWidth: 240 }}>
          <Stack spacing={1.5}>
            {/* Дата */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CalendarTodayIcon sx={{ color: 'primary.main', fontSize: 18 }} />
              <Typography variant="body2" sx={{ fontWeight: 600, textTransform: 'capitalize' }}>
                {/* *** ОНОВЛЕНО: Використання 'lang' *** */}
                {currentTime.toLocaleDateString(lang, {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
              </Typography>
            </Box>

            <Divider />

            {/* Час */}
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ 
                fontFamily: 'monospace',
                fontWeight: 700,
                color: 'text.primary'
              }}>
                {/* *** ОНОВЛЕНО: Використання 'lang' *** */}
                {currentTime.toLocaleTimeString(lang, {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                })}
              </Typography>
            </Box>

            <Divider />

            {/* Додаткова інформація */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                {/* *** ОНОВЛЕНО: Використання 't' *** */}
                {t('clock_timezone')} 
              </Typography>
              <Chip 
                label={formattedDatePopover} // Використовуємо 'lang'
                size="small"
                variant="outlined"
              />
            </Box>
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default function Layout({ children, user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { t, lang, setLang } = useI18n();

  // *** ДОДАЄМО ХУК ДЛЯ СПОВІЩЕНЬ ***
  const { unreadCount } = useNotifications();
  const [notificationOpen, setNotificationOpen] = useState(false);

  const [isShiftActive, setIsShiftActive] = useState(false);
  const { canAccess: canOpenSettings } = useHasSettingsAccess(user);

  // Розкривні групи меню
  const [staffMenuOpen, setStaffMenuOpen] = useState(false);
  const [maintenanceMenuOpen, setMaintenanceMenuOpen] = useState(false);
  const [archiveMenuOpen, setArchiveMenuOpen] = useState(
    location.pathname.startsWith('/archive/') && 
    !location.pathname.startsWith('/archive/incidents')
  );
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);
  const [incidentsMenuOpen, setIncidentsMenuOpen] = useState(
    location.pathname.startsWith('/incidents/') ||
    location.pathname.startsWith('/archive/incidents')
  );
  const [analyticsMenuOpen, setAnalyticsMenuOpen] = useState(
    location.pathname.startsWith('/analytics') || 
    location.pathname.startsWith('/meter-analysis') ||
    location.pathname.startsWith('/tunnel-analysis') ||
    location.pathname.startsWith('/washer-analysis')
  );
  const [partsMenuOpen, setPartsMenuOpen] = useState(
  location.pathname.startsWith('/parts-')
  );
  const [personnelMenuOpen, setPersonnelMenuOpen] = useState(false);

  // показувати Drawer тільки якщо це не auth-сторінка і користувач увійшов
  const AUTH_PREFIXES = ['/login', '/register', '/signup', '/new-user', '/auth', '/reset-password'];
  const isAuthRoute = AUTH_PREFIXES.some(p => location.pathname.startsWith(p));
  const showDrawer = !!user && !isAuthRoute;

  useEffect(() => {
    const checkShiftStatus = async () => {
      const shift = await getData('current_shift');
      setIsShiftActive(!!shift);
    };
    checkShiftStatus();
    const interval = setInterval(checkShiftStatus, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate('/login');
  };

  // Хелпер для нормальних підписів навіть якщо ключів поки немає
  const tt = (key, fallback) => {
    const v = t(key);
    return v === key ? fallback : v;
  };

  // Головні пункти меню
  const mainMenuItems = [
    { text: t('nav_panel'), icon: <DashboardIcon />, path: '/dashboard' },
    isShiftActive && { text: t('nav_machines'), icon: <LocalLaundryServiceIcon />, path: '/machines' },
  ].filter(Boolean);

  // НОВА ГРУПА МЕНЮ ДЛЯ АНАЛІТИКИ
  const analyticsSubMenuItems = [
    { text: tt('nav_analytics_general', 'Загальна аналітика'), icon: <BarChartIcon />, path: '/analytics' },
    { text: tt('nav_analytics_meters', 'Аналіз лічильників'), icon: <SpeedIcon />, path: '/meter-analysis' },
    { text: tt('nav_analytics_tunnel', 'Аналіз тунелю'), icon: <CountertopsIcon />, path: '/tunnel-analysis' },
    { text: tt('nav_analytics_washers', 'Аналіз пральних машин'), icon: <LocalLaundryServiceIcon />, path: '/washer-analysis' },
    { text: tt('nav_analytics_clients', 'Аналіз клієнтів'), icon: <PeopleIcon />, path: '/client-analysis' },
    { text: tt('nav_what_if_analysis', 'What-If Аналіз'), icon: <TimelineIcon />, path: '/what-if-analysis' },
    { text: tt('ai_dashboard_title', 'AI Панель'), icon: <PsychologyIcon />, path: '/ai-dashboard' },
    { text: tt('analytics_dashboard', 'Production Analytics'), icon: <AssessmentIcon />, path: '/analytics-dashboard' },
  ];
  
  const staffSubMenuItems = [
    { text: tt('nav_staff_directory', 'Каталог персоналу'), icon: <PeopleIcon />, path: '/staff' },
    { text: tt('nav_staff_roster', 'Графік персоналу'), icon: <CalendarMonthIcon />, path: '/staff-roster' },
    { text: tt('nav_attendance', 'Відмітка присутності'), icon: <CheckCircleIcon />, path: '/attendance' },
    { text: tt('nav_staff_analytics', 'Аналітика персоналу'), icon: <AssessmentIcon />, path: '/staff-analytics' },
    { text: tt('nav_time_off', 'Відпустки та відсутності'), icon: <BeachAccess />, path: '/timeoff'},
    { text: tt('nav_advanced_reports', 'Розширені звіти'), icon: <AnalyticsIcon />, path: '/reports'},
  ];

  // === ТЕХНІЧНЕ ОБСЛУГОВУВАННЯ - ОСНОВНІ ФУНКЦІЇ ===
const maintenanceSubMenuItems = [
  // === ЩОДЕННІ ОПЕРАЦІЇ ===
  { text: tt('nav_tech_report', 'Щоденний звіт техніка'), icon: <AssignmentTurnedInRoundedIcon />, path: '/technician-report'},
  { text: tt('nav_tech_form', 'Форма техніка'), icon: <ListAltIcon />, path: '/technician-form' },
  // === ОБЛАДНАННЯ ТА ТЕХОБСЛУГОВУВАННЯ ===
  { text: tt('nav_equipment', 'Обладнання'), icon: <HandymanIcon />, path: '/equipment' },
  { text: tt('nav_maintenance_log', 'Журнал обслуговування'), icon: <EngineeringIcon />, path: '/maintenance' },
  { text: tt('nav_maintenance_calendar', 'Календар обслуговування'), icon: <CalendarMonthIcon />, path: '/maintenance-calendar' },
  // === АНАЛІТИКА ТА ЗВІТИ ===
  { text: tt('nav_technician_analytics', 'Аналітика техніка'), icon: <AnalyticsIcon />, path: '/technician-stats' },
  { text: tt('nav_recurring_issues', 'Повторювані проблеми'), icon: <BugReportIcon />, path: '/recurring-issues' },
  { text: tt('nav_ml_analysis', 'ML Аналіз'), icon: <TrendingUpIcon />, path: '/technician-ml-analysis' },
  // === АРХІВ ТА ДОКУМЕНТАЦІЯ ===
  { text: tt('nav_technician_archive', 'Архів техніка'), icon: <ArchiveIcon />, path: '/archive/technician' },
  { text: tt('nav_issue_gallery', 'Галерея проблем'), icon: <PhotoLibraryIcon />, path: '/issue-gallery' },
  // === ДОДАТКОВІ ФУНКЦІЇ ===
  { text: tt('nav_ironing_assignments', 'Призначення прасування'), icon: <LocalLaundryServiceIcon />, path: '/iron-assignments' },
];

// === НОВА ГРУПА - ЗАПЧАСТИНИ ===
const partsSubMenuItems = [
  { text: tt('nav_parts_inventory', 'Склад запчастин'), icon: <InventoryIcon />, path: '/parts-inventory' },
  { text: tt('nav_parts_manager', 'Управління запчастинами'), icon: <BuildCircleIcon />, path: '/parts-manager' },
  { text: tt('nav_parts_analytics', 'Аналітика запчастин'), icon: <AnalyticsIcon />, path: '/parts-analytics' },
];

const personnelSubMenuItems = [
  { text: tt('training_title', 'Training & Certifications'), icon: <PeopleIcon />, path: '/training-management' },
  { text: tt('kpi_title', 'KPI & Performance'), icon: <TrendingUp />, path: '/kpi-management' },
  { text: tt('manuals_title', 'Manuals & Guides'), icon: <MenuBook />, path: '/manuals-guides' },
  { text: tt('integrations_title', 'Future Integrations'), icon: <IntegrationInstructions />, path: '/future-integrations' },
];

  const incidentsSubMenuItems = [
    { text: tt('menu.incidents_create', 'Створити інцидент'), icon: <ReportGmailerrorredIcon />, path: '/incidents/create' },
    { text: tt('menu.incidents_list', 'Список інцидентів'),   icon: <ReportGmailerrorredIcon />, path: '/incidents/list' },
    { text: tt('incidents_analytics_title', 'Аналітика інцидентів'), icon: <AssessmentIcon />, path: '/incidents/analytics' },
    { text: tt('incidents_ai_dashboard', 'AI Аналітика'), icon: <PsychologyIcon />, path: '/incidents/ai-dashboard' },
    { text: tt('incidents_patterns_analysis', 'Аналіз патернів'), icon: <TrendingUpIcon />, path: '/incidents/patterns' },
    { text: tt('incidents_iot_dashboard', 'IoT Моніторинг'), icon: <SensorsIcon />, path: '/incidents/iot-dashboard' },
    { text: tt('image_analysis_auto_detection', 'AI Аналіз фото'), icon: <ImageSearchIcon />, path: '/incidents/image-analysis' },
  ];

  // ОНОВЛЕНА ГРУПА АРХІВУ - тепер веде на нові сторінки
  const archiveSubMenuItems = [
    { text: tt('menu.archiveOperator', 'Звіти оператора'),  icon: <SummarizeIcon />, path: '/archive/operator' },
    { text: tt('menu.archiveTechnician', 'Звіти техніка'),  icon: <BuildCircleIcon />, path: '/archive/technician' },
    { text: tt('menu.archiveIncidents', 'Інциденти'),       icon: <ReportGmailerrorredIcon />, path: '/archive/incidents' },
    { text: tt('archive.tabs.meters', 'Контролери'),        icon: <SpeedIcon />, path: '/archive/meters' },
    { text: tt('menu.archiveMisc', 'Інше'),                 icon: <MoreHorizIcon />, path: '/archive/misc' },
  ];

  const adminSubMenuItems = [
    canOpenSettings && { text: tt('nav_settings', 'Налаштування'), icon: <SettingsIcon />, path: '/settings' },
    user?.role === 'admin' && { text: tt('nav_users', 'Користувачі'), icon: <PeopleIcon />, path: '/users-admin' },
    user?.role === 'admin' && { text: tt('nav_server_admin', 'Адміністрація сервера'), icon: <ComputerIcon />, path: '/server-admin' },
    { text: tt('nav_device_registration', 'Реєстрація пристроїв'), icon: <SmartphoneIcon />, path: '/device-registration' },
    { text: tt('nav_sync_status', 'Статус синхронізації'), icon: <SyncIcon />, path: '/sync-status' },
    { text: tt('nav_about', 'Про програму'), icon: <InfoIcon />, path: '/about' },
    { text: tt('nav_production_planning', 'Планування виробництва'), icon: <CalendarMonthIcon />, path: '/production-planning' },
  ].filter(Boolean);

  const currentYear = new Date().getFullYear();

  const MenuSection = ({ title, items, isOpen, onToggle, icon }) => (
    <>
      <ListItem disablePadding>
        <ListItemButton 
          onClick={onToggle}
          sx={{
            borderRadius: 1,
            mx: 1,
            mb: 0.5,
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            {icon}
          </ListItemIcon>
          <ListItemText 
            primary={title} 
            primaryTypographyProps={{ 
              fontSize: '0.9rem',
              fontWeight: 600 
            }}
          />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item) => (
            <ListItemButton
              key={item.path}
              component={Link}
              to={item.path}
              sx={{
                pl: 4,
                borderRadius: 1,
                mx: 1,
                mb: 0.5,
                backgroundColor: location.pathname === item.path 
                  ? alpha(theme.palette.primary.main, 0.12)
                  : 'transparent',
                '&:hover': {
                  backgroundColor: location.pathname === item.path 
                    ? alpha(theme.palette.primary.main, 0.16)
                    : alpha(theme.palette.action.hover, 0.04),
                }
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText 
                primary={item.text} 
                primaryTypographyProps={{ 
                  fontSize: '0.85rem',
                  fontWeight: location.pathname === item.path ? 600 : 400
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* Top bar */}
      <AppBar
        position="fixed"
        sx={{ 
          zIndex: (theme) => theme.zIndex.drawer + 1, 
          background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          boxShadow: '0 2px 12px rgba(0,0,0,0.1)'
        }}
        className="no-print"
      >
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          
          {/* --- 1. ЛОГОТИП (БЕЗ ЗМІН) --- */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 0 }}>
            <Link to={user ? '/dashboard' : '/login'} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <Avatar 
                src={LainsaLogo} 
                alt="Lainsa Logo" 
                sx={{ 
                  width: 40, 
                  height: 40,
                  mr: 2,
                  border: `2px solid ${alpha(theme.palette.common.white, 0.2)}`
                }} 
              />
              <Typography variant="h5" component="span" sx={{ color: 'white', fontWeight: 700 }}>
                {tt('brand', 'LAINSA')}
              </Typography>
            </Link>
          </Box>

          <Box sx={{ flexGrow: 1 }} />
          
          {/* --- 2. ПРАВА СТОРОНА (ОНОВЛЕНО ДЛЯ АДАПТИВНОСТІ) --- */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 1.5, lg: 2 } }}>
            
            {/* --- Погода та Годинник (Показуємо на ПЛАНШЕТАХ 'md' і вище) --- */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2, alignItems: 'center' }}>
              <CompactWeather />
              <CompactClock />
            </Box>
            
            {/* --- Прапори (Показуємо ТІЛЬКИ на ДЕСКТОПАХ 'lg' і вище) --- */}
            <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 0.5 }}>
              {[
                { code: 'es', flagCode: 'es', label: tt('lang_es', 'Español') },
                { code: 'uk', flagCode: 'ua', label: tt('lang_uk', 'Українська') },
                { code: 'ca', flagCode: 'es-ct', label: tt('lang_ca', 'Català') },
                { code: 'en', flagCode: 'gb', label: tt('lang_en', 'English') }
              ].map((langItem) => (
                <IconButton
                  key={langItem.code}
                  onClick={() => setLang(langItem.code)}
                  title={langItem.label}
                  sx={{
                    padding: '4px',
                    opacity: lang === langItem.code ? 1 : 0.65,
                    transform: lang === langItem.code ? 'scale(1.15)' : 'scale(1)',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      opacity: 1,
                      transform: 'scale(1.15)',
                      backgroundColor: alpha(theme.palette.common.white, 0.1),
                    }
                  }}
                >
                  <span
                    className={`fi fi-${langItem.flagCode}`}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      border: `2px solid ${lang === langItem.code 
                        ? theme.palette.common.white 
                        : alpha(theme.palette.common.white, 0.3)}`,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      backgroundSize: 'cover',
                      display: 'block',
                    }}
                  />
                </IconButton>
              ))}
            </Box>

            {/* --- Сповіщення (Завжди видимі) --- */}
            {user && (
              <IconButton 
                color="inherit" 
                onClick={() => setNotificationOpen(true)}
                sx={{
                  color: 'white',
                  background: alpha(theme.palette.common.white, 0.1),
                  borderRadius: 2,
                  px: { xs: 1, md: 1.5 }, // Менший padding на мобілках
                  py: 0.5,
                  border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
                  '&:hover': {
                    background: alpha(theme.palette.common.white, 0.2),
                  }
                }}
              >
                <Badge 
                  badgeContent={unreadCount} 
                  color="error"
                  max={99}
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            )}
            
            {/* --- Юзер та Вихід (ТІЛЬКИ ДЕСКТОП 'lg') --- */}
            {user && (
              <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 2 }}>
                <Chip
                  avatar={<Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem' }}>{user.username[0]}</Avatar>}
                  label={`${user.username} (${user.role})`}
                  variant="outlined"
                  sx={{
                    color: 'white',
                    borderColor: alpha(theme.palette.common.white, 0.3),
                    background: alpha(theme.palette.common.white, 0.1),
                    fontWeight: 600,
                  }}
                />
                <Button
                  color="inherit"
                  startIcon={<LogoutIcon />}
                  onClick={handleLogout}
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    background: alpha(theme.palette.error.main, 0.2),
                    borderRadius: 2,
                    px: 2,
                    '&:hover': {
                      background: alpha(theme.palette.error.main, 0.3),
                    }
                  }}
                >
                  {tt('nav_logout', 'Вийти')}
                </Button>
              </Box>
            )}

            {/* --- Юзер та Вихід (ТЕЛЕФОН + ПЛАНШЕТ 'xs' + 'md') --- */}
            {user && (
              <Box sx={{ display: { xs: 'flex', lg: 'none' }, alignItems: 'center', gap: 1 }}>
                {/* Аватар юзера */}
                <Avatar sx={{ width: 32, height: 32, fontSize: '0.9rem', bgcolor: alpha(theme.palette.common.white, 0.2) }}>
                  {user.username[0]}
                </Avatar>
                {/* Кнопка виходу (тільки іконка) */}
                <IconButton
                  onClick={handleLogout}
                  title={tt('nav_logout', 'Вийти')}
                  sx={{ 
                      color: 'white',
                      background: alpha(theme.palette.error.main, 0.2),
                      '&:hover': {
                          background: alpha(theme.palette.error.main, 0.3),
                      }
                  }}
                >
                  <LogoutIcon />
                </IconButton>
              </Box>
            )}

            {/* --- Кнопка "Увійти" (якщо не залогінений) --- */}
            {!user && (
              <Button 
                color="inherit" 
                onClick={() => navigate('/login')}
                sx={{ fontWeight: 600 }}
              >
                {tt('login', 'Увійти')}
              </Button>
            )}
          </Box>
        </Toolbar>
        {/* === КІНЕЦЬ ОНОВЛЕНОГО КОДУ TOOLBAR === */}
      </AppBar>

      {/* Left Drawer */}
      {showDrawer && (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': { 
              width: drawerWidth, 
              boxSizing: 'border-box',
              border: 'none',
              background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
              boxShadow: '2px 0 12px rgba(0,0,0,0.08)'
            }
          }}
          className="no-print"
        >
          <Toolbar />
          <Box sx={{ overflow: 'auto', padding: 2 }}>
            {/* Головні пункти */}
            <List sx={{ mb: 2 }}>
              {mainMenuItems.map((item) => (
                <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
                  <ListItemButton 
                    component={Link} 
                    to={item.path} 
                    selected={location.pathname === item.path}
                    sx={{
                      borderRadius: 1,
                      '&.Mui-selected': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.12),
                        '&:hover': {
                          backgroundColor: alpha(theme.palette.primary.main, 0.16),
                        }
                      }
                    }}
                  >
                    <ListItemIcon sx={{ 
                      minWidth: 40,
                      color: location.pathname === item.path ? theme.palette.primary.main : 'inherit'
                    }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.text} 
                      primaryTypographyProps={{ 
                        fontSize: '0.9rem',
                        fontWeight: location.pathname === item.path ? 600 : 400
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>

            <Divider sx={{ my: 2 }} />

            {/* Групи меню */}
            <List>
              {/* НОВА ГРУПА - АНАЛІТИКА */}
              <MenuSection
                title={tt('nav_analytics', 'Аналітика')}
                items={analyticsSubMenuItems}
                isOpen={analyticsMenuOpen}
                onToggle={() => setAnalyticsMenuOpen(o => !o)}
                icon={<BarChartIcon />}
              />

              {/* Інциденти */}
              <MenuSection
                title={tt('menu.incidents', 'Інциденти')}
                items={incidentsSubMenuItems}
                isOpen={incidentsMenuOpen}
                onToggle={() => setIncidentsMenuOpen(o => !o)}
                icon={<ReportGmailerrorredIcon />}
              />

              {/* АРХІВ - ОНОВЛЕНА ГРУПА */}
              <MenuSection
                title={tt('nav_archive', 'Архів')}
                items={archiveSubMenuItems}
                isOpen={archiveMenuOpen}
                onToggle={() => setArchiveMenuOpen(o => !o)}
                icon={<ArchiveIcon />}
              />

              {/* Персонал */}
              <MenuSection
                title={tt('nav_staff', 'Персонал')}
                items={staffSubMenuItems}
                isOpen={staffMenuOpen}
                onToggle={() => setStaffMenuOpen(o => !o)}
                icon={<PeopleIcon />}
              />

              {/* Технічне обслуговування */}
              <MenuSection
                title={tt('nav_maintenance', 'Технічне обслуговування')}
                items={maintenanceSubMenuItems}
                isOpen={maintenanceMenuOpen}
                onToggle={() => setMaintenanceMenuOpen(o => !o)}
                icon={<HandymanIcon />}
              />

              {/* Запчастини */}
              <MenuSection
                title={tt('nav_parts', 'Запчастини')}
                items={partsSubMenuItems}
                isOpen={partsMenuOpen}
                onToggle={() => setPartsMenuOpen(o => !o)}
                icon={<InventoryIcon />}
              />

              {/* HR/Personnel Management */}
              <MenuSection
                title={tt('personnel_management', 'Personnel Management')}
                items={personnelSubMenuItems}
                isOpen={personnelMenuOpen}
                onToggle={() => setPersonnelMenuOpen(o => !o)}
                icon={<PeopleIcon />}
              />

              {/* Адміністрування */}
              {adminSubMenuItems.length > 0 && (
                <MenuSection
                  title={tt('nav_admin', 'Адміністрування')}
                  items={adminSubMenuItems}
                  isOpen={adminMenuOpen}
                  onToggle={() => setAdminMenuOpen(o => !o)}
                  icon={<SettingsIcon />}
                />
              )}
            </List>
          </Box>
        </Drawer>
      )}

      {/* Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          minHeight: '100vh',
          background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
          pb: `${FOOTER_H + 16}px`, // Залишаємо відступ знизу для футера
        }}
      >
        <Toolbar />
        {children}

        {/* Оригінальний годинник з сезонами (прихований, але можна показати за потреби) */}
        {/* <Clock /> */}
      </Box>

      {/* *** ДОДАЄМО ПАНЕЛЬ СПОВІЩЕНЬ *** */}
      <NotificationPanel 
        open={notificationOpen}
        onClose={() => setNotificationOpen(false)}
      />

      {/* ОНОВЛЕНИЙ ФУТЕР */}
      <Box
        component="footer"
        className="no-print"
        sx={{
          position: 'fixed',
          left: showDrawer ? drawerWidth : 0,
          right: 0,
          bottom: 0,
          background: `linear-gradient(90deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
          borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          height: `${FOOTER_H}px`, // Використовуємо змінну висоти
          display: 'flex',
          flexDirection: 'column', // Розміщуємо рядки один під одним
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          backdropFilter: 'blur(8px)',
        }}
      >
        {/* Рядок з версією з package.json */}
        <Typography 
          variant="body2"
          component="div"
          color="text.secondary" 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: 1, 
            mb: 0.5 // Невеликий відступ між рядками
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar src={DevLogo} alt="SVH Group Logo" sx={{ width: 20, height: 20 }} />
            
            {/* *** ЗМІНЕНО РЯДОК (ВИПРАВЛЕННЯ ПОМИЛКИ) *** */}
            {/* Використовуємо 'pkg.name' та 'pkg.version' */}
            <span>{`SVH Group © 2025 - ${pkg.name} v${pkg.version}`}</span>
          </Box>
        </Typography>

        {/* Рядок з копірайтом Lainsa */}
        <Typography variant="caption" color="text.secondary">
          {tt('brand', 'LAINSA')} &copy; 1970 - {currentYear}
        </Typography>
      </Box>
    </Box>
  );
}